export default "__VITE_ASSET__CglTImx4__"